export const createConfigValueProvider = (configKey, canonicalEndpointParamKey, config) => {
  const configProvider = async () => {
    var _config$configKey;
    const configValue = (_config$configKey = config[configKey]) !== null && _config$configKey !== void 0 ? _config$configKey : config[canonicalEndpointParamKey];
    if (typeof configValue === "function") {
      return configValue();
    }
    return configValue;
  };
  if (configKey === "credentialScope" || canonicalEndpointParamKey === "CredentialScope") {
    return async () => {
      var _credentials$credenti;
      const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
      const configValue = (_credentials$credenti = credentials === null || credentials === void 0 ? void 0 : credentials.credentialScope) !== null && _credentials$credenti !== void 0 ? _credentials$credenti : credentials === null || credentials === void 0 ? void 0 : credentials.CredentialScope;
      return configValue;
    };
  }
  if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") {
    return async () => {
      const endpoint = await configProvider();
      if (endpoint && typeof endpoint === "object") {
        if ("url" in endpoint) {
          return endpoint.url.href;
        }
        if ("hostname" in endpoint) {
          const {
            protocol,
            hostname,
            port,
            path
          } = endpoint;
          return "".concat(protocol, "//").concat(hostname).concat(port ? ":" + port : "").concat(path);
        }
      }
      return endpoint;
    };
  }
  return configProvider;
};